// The pinned translation CLI only accepts two-letter locale codes. Keep this
// explicit resource list so the runtime receives the required pt-BR locale.
import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { coreComponentsTranslationRef } from '@backstage/core-components/alpha';
import { apiDocsTranslationRef } from '@backstage/plugin-api-docs/alpha';
import { catalogTranslationRef } from '@backstage/plugin-catalog/alpha';
import { catalogGraphTranslationRef } from '@backstage/plugin-catalog-graph/alpha';
import { catalogImportTranslationRef } from '@backstage/plugin-catalog-import/alpha';
import { catalogReactTranslationRef } from '@backstage/plugin-catalog-react/alpha';
import { kubernetesTranslationRef } from '@backstage/plugin-kubernetes/alpha';
import { kubernetesReactTranslationRef } from '@backstage/plugin-kubernetes-react/alpha';
import { notificationsTranslationRef } from '@backstage/plugin-notifications/alpha';
import { orgTranslationRef } from '@backstage/plugin-org/alpha';
import { scaffolderTranslationRef } from '@backstage/plugin-scaffolder/alpha';
import { scaffolderReactTranslationRef } from '@backstage/plugin-scaffolder-react/alpha';
import { searchTranslationRef } from '@backstage/plugin-search/alpha';
import { searchReactTranslationRef } from '@backstage/plugin-search-react/alpha';
import { techdocsTranslationRef } from '@backstage/plugin-techdocs/alpha';
import { userSettingsTranslationRef } from '@backstage/plugin-user-settings/alpha';

export default [
  createTranslationResource({
    ref: coreComponentsTranslationRef,
    translations: {
      'pt-BR': () =>
        import('../../translations/messages/core-components.pt-BR.json'),
    },
  }),
  createTranslationResource({
    ref: apiDocsTranslationRef,
    translations: {
      'pt-BR': () => import('../../translations/messages/api-docs.pt-BR.json'),
    },
  }),
  createTranslationResource({
    ref: catalogTranslationRef,
    translations: {
      'pt-BR': () => import('../../translations/messages/catalog.pt-BR.json'),
    },
  }),
  createTranslationResource({
    ref: catalogReactTranslationRef,
    translations: {
      'pt-BR': () =>
        import('../../translations/messages/catalog-react.pt-BR.json'),
    },
  }),
  createTranslationResource({
    ref: catalogGraphTranslationRef,
    translations: {
      'pt-BR': () =>
        import('../../translations/messages/catalog-graph.pt-BR.json'),
    },
  }),
  createTranslationResource({
    ref: catalogImportTranslationRef,
    translations: {
      'pt-BR': () =>
        import('../../translations/messages/catalog-import.pt-BR.json'),
    },
  }),
  createTranslationResource({
    ref: kubernetesTranslationRef,
    translations: {
      'pt-BR': () =>
        import('../../translations/messages/kubernetes.pt-BR.json'),
    },
  }),
  createTranslationResource({
    ref: kubernetesReactTranslationRef,
    translations: {
      'pt-BR': () =>
        import('../../translations/messages/kubernetes-react.pt-BR.json'),
    },
  }),
  createTranslationResource({
    ref: notificationsTranslationRef,
    translations: {
      'pt-BR': () =>
        import('../../translations/messages/plugin.notifications.pt-BR.json'),
    },
  }),
  createTranslationResource({
    ref: orgTranslationRef,
    translations: {
      'pt-BR': () => import('../../translations/messages/org.pt-BR.json'),
    },
  }),
  createTranslationResource({
    ref: scaffolderTranslationRef,
    translations: {
      'pt-BR': () =>
        import('../../translations/messages/scaffolder.pt-BR.json'),
    },
  }),
  createTranslationResource({
    ref: scaffolderReactTranslationRef,
    translations: {
      'pt-BR': () =>
        import('../../translations/messages/scaffolder-react.pt-BR.json'),
    },
  }),
  createTranslationResource({
    ref: searchTranslationRef,
    translations: {
      'pt-BR': () => import('../../translations/messages/search.pt-BR.json'),
    },
  }),
  createTranslationResource({
    ref: searchReactTranslationRef,
    translations: {
      'pt-BR': () =>
        import('../../translations/messages/search-react.pt-BR.json'),
    },
  }),
  createTranslationResource({
    ref: techdocsTranslationRef,
    translations: {
      'pt-BR': () => import('../../translations/messages/techdocs.pt-BR.json'),
    },
  }),
  createTranslationResource({
    ref: userSettingsTranslationRef,
    translations: {
      'pt-BR': () =>
        import('../../translations/messages/user-settings.pt-BR.json'),
    },
  }),
];
